import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { captureAxiosError } from './sentry.config';

const apiUrl = Constants.manifest.extra.REACT_APP_URL_BASE;
const haciendaApiUrl = Constants.manifest.extra.HACIENDA_API_BASE;

export const getToken = async () =>
  (await AsyncStorage.getItem('user'))
    ? JSON.parse(await AsyncStorage.getItem('user')).accessToken
    : null;

export const getAuthorizationHeader = async () => {
  const token = await getToken();
  return { Authorization: `Bearer ${token}` };
};

const axiosIntance = axios.create({
  baseURL: apiUrl,
  timeout: 2 * 60 * 1000, // 2 minutos en milisegundos (120000 ms)
});

// For GET requests
axiosIntance.interceptors.request.use(
  async (config) => {
    const token = (await AsyncStorage.getItem('user'))
      ? JSON.parse(await AsyncStorage.getItem('user')).accessToken
      : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// For POST requests
axiosIntance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    console.log('error response ', err);
    if (
      err.response &&
      err.response?.status === 401 &&
      err.response?.data?.message === 'Unauthorized'
    ) {
      await AsyncStorage.removeItem('user');
      await AsyncStorage.removeItem('notificationAssiatance');
      await AsyncStorage.removeItem('notificationOrders');
      await AsyncStorage.removeItem('savedOrder');
      await AsyncStorage.removeItem('P');
      await AsyncStorage.removeItem('inventoryMassiveForm');
      await AsyncStorage.removeItem('foodComplementsMassiveForm');
      return (window.location.href = '/');
    }
    await captureAxiosError(err);
    return Promise.reject(err);
  }
);

export { apiUrl, haciendaApiUrl, axiosIntance };
